import { AppShell, AppShellBody, AppShellContent, AppShellMain } from '@ordo/ui/app-shell'
import { Outlet, useLocation } from 'react-router'
import { useAuthStore } from 'stores/auth'

import { ProtectedRoute } from './ProtectedRoute'
import { PwaPrompt } from './PwaPrompt'
import { Sidebar } from './Sidebar'
import { TopBar } from './TopBar'

function AuthedShell() {
  const user = useAuthStore((s) => s.user)
  // `pathname` lets AppShell close the mobile menu drawer on navigation.
  const { pathname } = useLocation()
  if (!user) {
    return null
  }
  // Unified internal-tools shell: full-width top bar on desktop; on phones
  // TopBar renders the floating top row and the bottom-right search.
  return (
    <AppShell layout="unified" pathname={pathname}>
      <TopBar user={user} />
      <AppShellBody>
        <Sidebar user={user} />
        <AppShellContent>
          <AppShellMain>
            <Outlet />
          </AppShellMain>
        </AppShellContent>
      </AppShellBody>
    </AppShell>
  )
}

export function RootShell() {
  return (
    <ProtectedRoute>
      <AuthedShell />
      <PwaPrompt />
    </ProtectedRoute>
  )
}
